import { processamentoIAService } from "@/services/api/processamento-ia.service";
import { useQuery } from "@tanstack/react-query";

export function useProcessamentoIADetails(id: number) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["processamento-ia", id],
    queryFn: () => processamentoIAService.getById(id),
    enabled: !!id,
  });

  return { processamento: data, isLoading, error };
}
